import { BehaviorSubject } from 'rxjs';
import { LocaleProvider, LANGUAGE, Language, useLocale as useLocaleExternal } from '@poinz/locale';
export { LocaleContext, withLocale } from '@poinz/locale';
export type { LanguageInput, NumberInput, LocaleProviderProps as LocaleProps } from '@poinz/locale';
export default LocaleProvider;

export { useLocaleExternal as useLocale };
export const localeSubject = new BehaviorSubject<Language>(LANGUAGE.de as any);
